/**
 * UI Components - Barrel Export
 *
 * Import all shared UI components from one place:
 *   import { Button, FormInput, DataTable, Badge } from '@/components/ui';
 */

export { default as Button } from './Button';
export { default as FormInput } from './FormInput';
export { default as FormSelect } from './FormSelect';
export { default as FormTextarea } from './FormTextarea';
export { SearchableSelect } from './SearchableSelect';
export { FormField, Input, Select, Textarea } from './FormComponents';
export { default as DataTable } from './DataTable';
export { ModernTable } from './ModernTable';
export { DropdownMenu } from './DropdownMenu';

export { default as Badge, LeadStatusBadge, ProjectStatusBadge } from './Badge';
export { default as Modal } from './Modal';
export { default as Card } from './Card';
export { default as SearchBar } from './SearchBar';
export { default as EmptyState } from './EmptyState';
export { default as Avatar } from './Avatar';
export { default as StatCard } from './StatCard';
export { default as Pagination } from './Pagination';
export { default as FilterToggleButton } from './FilterToggleButton';
export { default as DateFilter } from './DateFilter';
export { default as ViewToggle } from './ViewToggle';
export { default as SearchOverlay } from './SearchOverlay';
export { PageLoader, InlineLoader, Skeleton } from './Loader';
export { FileUpload } from './FileUpload';


export { default as KanbanBoard } from './KanbanBoard';

export { UnifiedKanbanCard } from './UnifiedKanbanCard';
export { default as FilterSection } from './FilterSection';
export { default as AdvancedFilters } from './AdvancedFilters';
export { Tabs } from './Tabs';
export {
  PageTitle,
  SectionTitle,
  SectionSubtitle,
  Label,
  BodyText,
  SubText,
  Caption,
  ErrorText,
  HighlightText,
} from './Typography';
export { default as DonutWithLegend } from './DonutWithLegend';
export { default as ProgressBar } from './ProgressBar';
export * from './RichTextEditor';
export { default as TableActionButton } from './TableActionButton';
export { default as Toast } from './Toast';
export { default as ConfirmationModal } from './ConfirmationModal';
export { default as TableActions } from './TableActions';
export { default as DetailsWorkspaceModal } from './DetailsWorkspaceModal';
export { TableStyles } from './TableStyles';
export * from './LatestTableActions';
export { useRowHighlight } from './RowHighlight';

export * from './HeroBanner';
export * from './NewStatCard';
export * from './NewTabs';
export * from './FilterBar';
export * from './NewTable';

export const formatCurrency = (amount) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount);
export const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

export { default as OnlyOfficeEditor } from './OnlyOfficeEditor';
export { FormHeader } from './FormHeader';
export { FormActionButtons } from './FormActionButtons';
